var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { getHeaders } from "../utils/apiUtils";
import { MAX_LIST_LIMIT } from "../utils/fetchAllPages";
/**
 * @param signal aborts the request, e.g. when react-query drops a search
 *   superseded by further typing (DB-902). Only the browser request and its
 *   connection are freed; a query the backend already started still runs to
 *   its end.
 */
export var fetchPersonSearchOptions = function (kyInstance, filters, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var nameFilter, legalForm, sourceIdFilter, _a, limit, linkedOnly, params, response;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                nameFilter = filters.nameFilter, legalForm = filters.legalForm, sourceIdFilter = filters.sourceIdFilter, _a = filters.limit, limit = _a === void 0 ? 20 : _a, linkedOnly = filters.linkedOnly;
                params = new URLSearchParams();
                if (nameFilter)
                    params.append("nameFilter", nameFilter);
                if (legalForm)
                    params.append("legalForm", legalForm);
                if (sourceIdFilter)
                    params.append("sourceIdFilter", sourceIdFilter);
                params.append("limit", limit.toString());
                if (linkedOnly)
                    params.append("linkedOnly", "true");
                return [4 /*yield*/, kyInstance.get("persons/search-options", {
                        searchParams: params,
                        headers: getHeaders(),
                        signal: signal,
                    })];
            case 1:
                response = _b.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchPersons = function (kyInstance, filters) { return __awaiter(void 0, void 0, void 0, function () {
    var nameFilter, _a, offset, _b, limit, params, response, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 4]);
                nameFilter = filters.nameFilter, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? MAX_LIST_LIMIT : _b;
                params = new URLSearchParams();
                if (nameFilter) {
                    params.append("nameFilter", nameFilter);
                }
                params.append("offset", offset.toString());
                params.append("limit", limit.toString());
                return [4 /*yield*/, kyInstance.get("persons", {
                        searchParams: params,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _c.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _c.sent()];
            case 3:
                error_1 = _c.sent();
                console.error("Error fetching persons:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var usePersons = function (filters, options) {
    var _a;
    var ky = useOkapiKy();
    return useQuery(["persons", filters], function () { return fetchPersons(ky, filters); }, {
        enabled: (_a = options === null || options === void 0 ? void 0 : options.enabled) !== null && _a !== void 0 ? _a : true,
        onSuccess: options === null || options === void 0 ? void 0 : options.onSuccess,
        onError: options === null || options === void 0 ? void 0 : options.onError,
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000,
    });
};
